var render = function render(){var _vm=this,_c=_vm._self._c;return (
        _vm.readers &&
        _vm.readers.length > 0
    )?_c('div',{staticClass:"ml-2 readerContainer"},[_c('b-tooltip',{attrs:{"label":"Leser","position":"is-bottom"}},[_c('div',{staticStyle:{"display":"grid","grid-template-columns":"repeat(2, 0.1fr)","grid-template-areas":"'icon num'"}},[_c('div',{staticStyle:{"grid-area":"icon"}},[_c('b-icon',{attrs:{"icon":"account"}})],1),_c('div',{staticClass:"readNumber",staticStyle:{"grid-area":"num"}},[_vm._v(" "+_vm._s(_vm.readers && _vm.readers.length)+" ")])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }